<div class="modal-header" *transloco="let t; prefix: 'compliance.overview.assignWorkshopModal'">
  <h5 class="modal-title">{{ t('title') }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()" [disabled]="isLoading">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'compliance.overview.assignWorkshopModal'">
  <form [formGroup]="assignWorkshopForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label>{{ t('workshop') }}<span class="required">*</span></label>

      <div ngbDropdown class="custom-dropdown" [autoClose]="true">
        <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle [disabled]="isLoadingWorkshops || isLoading">
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle">{{ isLoadingWorkshops ? t('loadingWorkshopsShort') : workshopLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>

        <div ngbDropdownMenu>
          <div class="d-flex flex-column">
            @if (isLoadingWorkshops) {
              <div class="dropdown-loading">
                <span class="spinner-border spinner-border-sm"></span>
                <span>{{ t('loadingWorkshops') }}</span>
              </div>
            } @else if (workshops.length === 0) {
              <div class="dropdown-loading">
                <span>{{ t('noWorkshopsFound') }}</span>
              </div>
            } @else {
              @for (workshop of workshops; track workshop.id) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onWorkshopSelect(workshop, $event)">
                  {{ workshop.name }}
                </button>
              }
            }
          </div>
        </div>
      </div>

      @if (assignWorkshopForm.get('workshopId')?.invalid && assignWorkshopForm.get('workshopId')?.touched) {
        <div class="error-message">{{ t('workshopRequired') }}</div>
      }
    </div>

    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onCancel()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>

      <button type="submit" class="add-btn" [disabled]="isLoading || assignWorkshopForm.invalid || !hasChanges">
        @if (isLoading) {
          <span class="spinner-border spinner-border-sm"></span>
        }
        @if (!isLoading) {
          <span>{{ 'common.saveChanges' | transloco }}</span>
        }
      </button>
    </div>
  </form>
</div>